import {
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { FunctionComponent, useEffect, useState } from "react";
import { api } from "../../../api";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { TablePaginationActions } from "../../TablePagination";
import { useServiceStyles } from "../useServiceStyles";

type PosServiceTableProps = {
  tableData: Array<any>;
  serviceDetails: any;
  handleTerminalService: (
    is_sync_active: boolean,
    terminal_id: number,
    service_id: number,
    selectAll: boolean
  ) => void;
};

export const PosServiceTableList: FunctionComponent<PosServiceTableProps> = ({
  tableData,
  serviceDetails,
  handleTerminalService,
}) => {
  const classes = useServiceStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const terminalIds = tableData.map((i: any) => i.terminal_id);
  const arr = [...new Set(terminalIds)];

  const filterPosServices =
    serviceDetails.services &&
    serviceDetails.services.filter((i: any) => i.is_pos === "1");

  const services = ["Terminals"];
  const serviceNames =
    filterPosServices && filterPosServices.map((i: any) => i.display_name);
  const newArray = services.concat(serviceNames);

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {newArray.map((i: any) => (
                <TableCell>{i}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {arr
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row: any) => (
                <TableRow key={row.terminal_id}>
                  <TableCell component="th" scope="row">
                    {
                      // row.terminal_name
                      tableData.find((i: any) => i.terminal_id === row) !==
                      undefined
                        ? tableData.find((i: any) => i.terminal_id === row)
                            .terminal_name
                        : ""
                    }
                  </TableCell>
                  {filterPosServices &&
                    filterPosServices.map((j: any) => (
                      <TableCell component="th" scope="row">
                        <Grid container>
                          <Switch
                            checked={
                              // tableData.find((i:any)=>i.terminal_id===row && i.service_id===j)!==undefined?
                              tableData.find(
                                (i: any) =>
                                  i.terminal_id === row &&
                                  i.service_id === j.service_id
                              ).is_sync_active === "1"
                                ? // row.is_sync_active === "1" ?
                                  true
                                : false
                              // :false
                            }
                            onClick={() => {
                              handleTerminalService(
                                tableData.find(
                                  (i: any) =>
                                    i.terminal_id === row &&
                                    i.service_id === j.service_id
                                ).is_sync_active === "1"
                                  ? false
                                  : true,
                                row,
                                j.service_id,
                                false
                              );
                            }}
                            color="primary"
                            name="status"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                          <Typography
                            variant="h5"
                            className={classes.switchLabels}
                          >
                            {tableData.find(
                              (i: any) =>
                                i.terminal_id === row &&
                                i.service_id === j.service_id
                            ).is_sync_active === "1"
                              ? "On"
                              : "Off"}
                          </Typography>
                        </Grid>
                      </TableCell>
                    ))}
                </TableRow>
              ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  50,
                  75,
                  100,
                  //, { label: 'All', value: -1 }
                ]}
                colSpan={6}
                count={0 && tableData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};
